import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Blog from "../Blog";
import { getUser, removeUser } from "../utils/auth";
import { clearPenStorage } from "../utils/penStorage";

export default function BlogPage() {
  const navigate        = useNavigate();
  const [user, setUser] = useState(getUser);

  const handleLogout = () => {
    removeUser();
    setUser(null);
    navigate('/');
  };

  const handleNewPen = () => {
    clearPenStorage();
    navigate('/editor');
  };

  return (
    <Blog
      user={user}
      onGoHome={() => navigate('/')}
      onReadPost={(slug) => navigate(`/blog/${slug}`)}
      onEditor={() => navigate('/editor')}
      onExplore={() => navigate('/explore')}
      onLogin={() => navigate('/login')}
      onNewPen={handleNewPen}
      onViewPens={() => navigate('/editor?pens=true')}
      onSettings={() => navigate('/editor?settings=true')}
      onLogout={handleLogout}
    />
  );
}
